import type {
  FavoriteDesignTemplateByData,
  GenerateImageUploadPresignedUrlData,
  GetDesignTemplateData,
  GetDesignTemplatesByData,
  GetDesignTemplatesByParams,
  GetFavoriteDesignTemplatesData,
  UnfavoriteDesignTemplateByData,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptDesignTemplate, adaptDesignTemplateSummaries, adaptImageUploadUrl } from './adapters'
import type { DesignTemplate, DesignTemplateSummary, ImageUploadUrl } from './schemas'

export type DesignTemplateListParams = GetDesignTemplatesByParams

// 목록·즐겨찾기 목록은 CommonResponse 봉투 없이 배열을 그대로 준다.
export const getDesignTemplates = async (
  params: DesignTemplateListParams,
  meta?: RequestMeta,
): Promise<DesignTemplateSummary[]> => {
  const body = await httpClient().get<GetDesignTemplatesByData>('/design-template', {
    params,
    meta,
  })
  return adaptDesignTemplateSummaries(body)
}

export const getDesignTemplate = async (
  id: DesignTemplate['id'],
  meta?: RequestMeta,
): Promise<DesignTemplate> => {
  const body = await httpClient().get<GetDesignTemplateData>(`/design-template/${id}`, { meta })
  return adaptDesignTemplate(body.data)
}

export const getFavoriteDesignTemplates = async (
  meta?: RequestMeta,
): Promise<DesignTemplateSummary[]> => {
  const body = await httpClient().get<GetFavoriteDesignTemplatesData>('/design-template/favorite', {
    meta,
  })
  return adaptDesignTemplateSummaries(body)
}

export const favoriteDesignTemplate = async (
  id: DesignTemplate['id'],
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().post<FavoriteDesignTemplateByData>(
    `/design-template/${id}/favorite`,
    undefined,
    { meta },
  )
}

export const unfavoriteDesignTemplate = async (
  id: DesignTemplate['id'],
  meta?: RequestMeta,
): Promise<void> => {
  await httpClient().delete<UnfavoriteDesignTemplateByData>(`/design-template/${id}/favorite`, {
    meta,
  })
}

/** 표지 로고 이미지를 올릴 주소를 받는다. 응답은 CommonResponse 봉투 없이 온다 */
export const createImageUploadUrl = async (meta?: RequestMeta): Promise<ImageUploadUrl> =>
  adaptImageUploadUrl(
    await httpClient().post<GenerateImageUploadPresignedUrlData>('/images', undefined, { meta }),
  )
